import { inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavDataService } from './services';

/**
 * This class is used to redirect the user to the destination url after login/register.
 */
export class RouteRedirectAfterAction {
  /**
   *  Current activated route.
   */
  protected route: ActivatedRoute = inject(ActivatedRoute);
  /**
   *  Indicates if the user has to be redirected after login/register.
   */
  protected hasToRedirect: any = false;
  /**
   *  The url to redirect to after login/register.
   */
  protected redirectUrl?: string;
  /**
   *  The query params to redirect to after login/register.
   */
  protected redirectQueryParams: any;
  /**
   *  The destination param raw from the url.
   */
  protected redirectParam: any = null;
  /**
   *  The destination param for the template.
   */
  protected redirectParamForTemplate = signal<any>(null);
  protected navDataService: NavDataService = inject(NavDataService);

  constructor() {
    if (!this.route.snapshot.queryParams.destination) {
      this.hasToRedirect = false;
      return;
    }
    this.hasToRedirect = true;
    this.redirectParam = this.route.snapshot.queryParams.destination;
    this.redirectParamForTemplate.set({ destination: this.redirectParam });
    const redirectDest = this.redirectParam.split('?');
    this.redirectUrl = redirectDest[0];
    // extract the query params from the destination
    if (redirectDest?.length > 1) {
      this.redirectQueryParams = {
        queryParams: redirectDest[1]
          .split('&')
          .map((param: any) => param.split('='))
          .reduce((acc: any, curr: any) => {
            acc[curr[0]] = curr[1];
            return acc;
          }, {}),
      };
    }
  }

  protected executeNavigation(url: string) {
    if (this.hasToRedirect) {
      this.navDataService.replaceUrl(url);
    }
    // Delay the redirection more if there is another redirection in the url component like /account
    setTimeout(() => {
      this.navDataService.navigate(
        this.hasToRedirect ? this.redirectUrl : (url as any),
        false,
        this.redirectQueryParams
      );
    });
  }
}
